export type SubscriptionProductType = ApplicationAccess | DataPackages;

export enum ApplicationAccess {
    TRACTIQ_SELF_STORAGE_MAX = 'ACCESS__TRACTIQ_SELFSTORAGE_MAX',
    TRACTIQ_SELF_STORAGE_PRO_PLUS = 'ACCESS__TRACTIQ_SELFSTORAGE_PRO_PLUS',
    TRACTIQ_SELF_STORAGE = 'ACCESS__TRACTIQ_SELFSTORAGE',
    TRACTIQ_SELF_STORAGE_STARTER_TIER = 'ACCESS__TRACTIQ_SELFSTORAGE_STARTER_TIER',
}

export enum ApplicationAccessConfigurationOptions {
    ENABLE_RAW_DATA_EXPORT = 'ACCESS__TRACTIQ_SELFSTORAGE__ENABLE_RAW_DATA_EXPORT',
    ENABLE_SITE_ANALYSIS_API = 'ACCESS__TRACTIQ_SELFSTORAGE__ENABLE_SITE_ANALYSIS_API',
}

export enum DataPackages {
    TRACTIQ_SELF_STORAGE_BASE = 'DATA_PACKAGE__TRACTIQ_SELFSTORAGE_BASE',
    PROPRIETARY_SINGLE_LOCATION_REPORT = 'DATA_PACKAGE__PROPRIETARY_SINGLE_LOCATION_REPORT',
}
